<template>
<div></div>
  <!-- <section class="getintouch" v-if="!isMember">
    <v-container fluid >
      <div class="getintouch-container">
        <v-row>
          <v-col sm="4" class="getintouch-text">
            <div>
              <div
                class="text-h3 text-primary font-weight-bold"
                v-text="'Want To Learn About Member Benefits?'"
              ></div>
              <div
                class="text-subtitle-2 text-secondary mt-2"
                v-text="
                  'Fill out this form and we will reach out to help get you closer to the most exciting step you could take all year.'
                "
              ></div>
              <div class="getintouch-button">
                <v-btn
                  large
                  color="accent"
                  block
                  :to="'/membership'"
                  :variant="'danger'"
                >
                  Get in Touch <v-icon>mdi-arrow-right-thin</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
  <section v-else>
  </section> -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Getintouch",
  components: {
    // Button,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    isMember() {
      return this.user?.member;
    },
  },
  data() {
    return {
      to: "/membership",
      variant: "danger",
    };
  }
};
</script>

<style scoped lang="scss">
.getintouch {
  // padding: 10px;
  margin: 10px 0px;
  // position: relative;
  height: 503px;
  background: url(../../assets/membership-bg.png) no-repeat center center;
  &-image {
    width: 100%;
    object-fit: cover;
    position: relative;
  }
  &-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 25px;
    display: flex;
    align-items: center;
  }
  &-container {
    position: relative;
    left: 5%;
    top: 100px;
  }
  &-image {
    width: 100%;
    height: auto;
    // object-fit: cover;
  }
  &-text {
    color: var(--light);
    margin-bottom: 30px;
  }
  &-button {
    margin-top: 20px;
    width: 80%;
    // position: relative;

    // z-index: 2;
  }
}
</style>
